import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ModalCardOk from "../ModalCardOk";
import { isObjectEmpty } from "../../organisms/utils";
import { getMessengerService } from "../../../store/actions";
import { getMessage } from "../../organisms/utils";
import { executeTaggeo } from "../../../store/actions";
import { setFromActionValue } from "../../../store/actions/domiciliation";
import { formatCurrency } from "../../organisms/utils";
import { setMaxAmountValue } from "../../../store/actions/domiciliation";

export default class HasDomiciliationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openHasDomiciliationModal: false,
      CpMessage: "CP0005",
    };
  }

  componentDidMount() {
    const {
      hasDmError,
      hasDmResponse,
      getMessengerService,
      history,
      accountValue,
      amount,
      tagServiceId,
      executeTaggeo,
      setFromActionValue,
      setMaxAmountValue
    } = this.props;
    let alertId = "";
    if (!isObjectEmpty(hasDmResponse) && hasDmResponse.data) {
      const {
        data: { domiciliation },
      } = hasDmResponse;
      if (domiciliation) {
        getMessengerService("PagosProgramados");
        setTimeout(() => {
          this.setState({
            openHasDomiciliationModal: true,
            CpMessage: "CP0014",
          });
        }, 400);

        alertId = "Servicio con pago ya domiciliado";
      } else {
        setFromActionValue("clickButtonDomiciliation")
        setMaxAmountValue(formatCurrency.format(amount.replace(/(,)/gm, "")))
        history.push({
          pathname: `schedule-telcel-bill-payments`,
          state: { accountValue, amount, tagServiceId },
        });
      }
    }
    if (hasDmError) {
      getMessengerService("PagosProgramados");
      setTimeout(() => {
        this.setState({ CpMessage: "CP0013", openHasDomiciliationModal: true });
      }, 400);
      alertId = "Domiciliación no completada";
    }
    setTimeout(() => {
      executeTaggeo({
        action: "View alert",
        step:
          tagServiceId === "serviciopagotelcelMenu"
            ? "Pantalla principal"
            : "Formulario de pago",
        service: tagServiceId,
        alert_id: alertId,
        eventName: tagServiceId === "serviciopagotelcelMenu"
          ? "telcel"
          : "pay_service_or_tae",
      });
    }, 800);
  }

  handleOnclickModal = () => {
    const { tagServiceId, executeTaggeo, hasDmError } = this.props;
    this.setState({ openHasDomiciliationModal: false });
    executeTaggeo({
      action: "Click alert Entendido",
      service: tagServiceId,
      step: tagServiceId === "serviciopagotelcelMenu"
        ? "Pantalla principal"
        : "Formulario de pago",       
      alert_id: hasDmError
        ? "Domiciliación no completada"
        : "Servicio con pago ya domiciliado",
      eventName: tagServiceId === "serviciopagotelcelMenu"
      ? "telcel"
      : "pay_service_or_tae",
    });
  };

  render() {
    const { openHasDomiciliationModal, CpMessage } = this.state;
    const { messagesDomiciliation } = this.props;
    let messageInformation = { data: {} };
    if (messagesDomiciliation.length !== 0) {
      messageInformation = getMessage(messagesDomiciliation, CpMessage);
    }
    return (
      <ModalCardOk
        isOpen={openHasDomiciliationModal}
        srcImage={messageInformation.data.icon}
        text={messageInformation.data.subject}
        textdetail={messageInformation.data.message}
        buttontext={"Entendido"}
        onclickModal={this.handleOnclickModal}
        fontSizeTitle={"20px"}
        fontFamilyTitle={"NunitoBold"}
      />
    );
  }
}

function mapStateToProps(state) {
  const { domiciliationReducer: { messagesDomiciliation } = [] } = state;
  return {
    messagesDomiciliation,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getMessengerService,
      executeTaggeo,
      setFromActionValue,
      setMaxAmountValue
    },
    dispatch
  );
}

HasDomiciliationModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(HasDomiciliationModal);
